import * as keypair from 'keypair';
import { JSEncrypt } from 'jsencrypt';
import * as CryptoJS from 'crypto-js';

class Crypto {
  static KEY = 'app-key';
  private secretKey: string;
  private private: string;
  private public: string;

  constructor() {
    if (localStorage.getItem(Crypto.KEY)) {
      let key = CryptoJS.AES.decrypt(localStorage.getItem(Crypto.KEY), 'encrypted').toString(CryptoJS.enc.Utf8);
      if (!key) {
        return;
      }
      this.setKey(key, false);
    }
  }

  addToStore() {
    localStorage.setItem(Crypto.KEY, CryptoJS.AES.encrypt(this.secretKey, 'encrypted').toString());
  }

  removeFromStore() {
    localStorage.removeItem(Crypto.KEY);
  }

  setKey(key: string, hash = true) {
    if (hash) {
      this.secretKey = this.hash(key);
    } else {
      this.secretKey = key;
    }
  }

  reset() {
    this.secretKey = null;
    this.removeFromStore();
  }

  getHashedKey() {
    return this.secretKey && this.hash(this.secretKey);
  }

  hash(key) {
    return CryptoJS.SHA256(key).toString();
  }

  encrypt(msg: number | string, secretKey = this.secretKey): string {
    if (typeof msg === 'number') {
      msg = msg.toString();
    }
    if (!secretKey) {
      return msg;
    }
    return CryptoJS.AES.encrypt(msg, secretKey).toString();
  }

  decrypt(cypher: string, secretKey = this.secretKey): string {
    if (!secretKey) {
      return cypher;
    }
    if (!cypher) {
      return cypher;
    }
    try {
      return CryptoJS.AES.decrypt(cypher, secretKey).toString(CryptoJS.enc.Utf8);
    } catch (e) {
      console.log(e);
      this.removeFromStore();
      return cypher;
    }
  }

  createPair() {
    let pair = keypair();
    pair.private = this.encrypt(pair.private);
    return pair;
  }

  setPrivateRsaKey(privateKey) {
    this.private = this.decrypt(privateKey);
  }

  setPublicRsaKey(publicKey) {
    this.public = publicKey;
  }

  decryptRsa(message) {
    const encrypt = new JSEncrypt();
    encrypt.setKey(this.private);
    return encrypt.decrypt(message);
  }
}

export default new Crypto();



// WEBPACK FOOTER //
// ./src/services/crypto.service.ts